import { Pipe, PipeTransform } from '@angular/core';
import { OpportunityChannel, ProjectChannels } from 'sustainment-component';

@Pipe({
    name: 'projectOpportunityChannelSort',
    pure: true,
    standalone: false
})
export class ProjectOpportunityChannelSortPipe implements PipeTransform {
  public transform(
    opportunityChannels: OpportunityChannel[]
  ): OpportunityChannel[];
  public transform(projectChats: ProjectChannels[]): ProjectChannels[];

  public transform(
    projectsOrOpportunities: ProjectChannels[] | OpportunityChannel[]
  ): ProjectChannels[] | OpportunityChannel[] {
    if (!this.isProjects(projectsOrOpportunities)) {
      const opportunityChannels = projectsOrOpportunities;

      const unread = opportunityChannels.filter((channel) => channel.isUnread);
      const read = opportunityChannels.filter((channel) => !channel.isUnread);

      unread.sort((a, b) => b.lastMessageTimeStamp - a.lastMessageTimeStamp);
      read.sort((a, b) => b.lastMessageTimeStamp - a.lastMessageTimeStamp);

      return [...unread, ...read];
    }

    const sortedChats = projectsOrOpportunities
      .map((projectChat) => {
        const unread = projectChat.channels.filter(
          (channel) => channel.isUnread
        );
        const read = projectChat.channels.filter(
          (channel) => !channel.isUnread
        );

        unread.sort((a, b) => b.lastMessageTimeStamp - a.lastMessageTimeStamp);
        read.sort((a, b) => b.lastMessageTimeStamp - a.lastMessageTimeStamp);

        return {
          ...projectChat,
          channels: [...unread, ...read],
        };
      })
      .sort((a, b) => {
        const mostRecentUnreadA = a.channels
          .filter((channel) => channel.isUnread)
          .reduce(
            (max, channel) => Math.max(max, channel.lastMessageTimeStamp),
            0
          );

        const mostRecentUnreadB = b.channels
          .filter((channel) => channel.isUnread)
          .reduce(
            (max, channel) => Math.max(max, channel.lastMessageTimeStamp),
            0
          );

        if (mostRecentUnreadA && mostRecentUnreadB) {
          return mostRecentUnreadB - mostRecentUnreadA;
        }

        if (mostRecentUnreadA) return -1;
        if (mostRecentUnreadB) return 1;

        const mostRecentReadA = a.channels.reduce(
          (max, channel) => Math.max(max, channel.lastMessageTimeStamp),
          0
        );

        const mostRecentReadB = b.channels.reduce(
          (max, channel) => Math.max(max, channel.lastMessageTimeStamp),
          0
        );

        return mostRecentReadB - mostRecentReadA;
      });

    return sortedChats;
  }

  private isProjects(
    projectsOrOpportunities: ProjectChannels[] | OpportunityChannel[]
  ): projectsOrOpportunities is ProjectChannels[] {
    return projectsOrOpportunities.some((projOrOpp) => 'channels' in projOrOpp);
  }
}
